import React, { useContext, useEffect, useRef, useState } from 'react';
import { FastField, Field, FieldArray, Form, Formik, Reset } from 'formik';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import Switch from 'react-switch';
import Layout from 'components/Layout';
import InputField from 'components/Form/InputField';
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import { ButtonContainer, ButtonMiradorOrange, ButtonMiradorWhite } from 'components/Button';
import FormContainer from 'components/FormContainer';
import Label from 'components/Form/Label';
import TextField from 'components/Form/TextField';
import { Text } from 'components/Text';
import ContentCard from 'components/ContentCard';
import _, { initial, repeat } from 'lodash';
import { AddButton, BorderSwitch, CalendarContainer, Content, Heading, PlaceHolder, TagInput, ButtonContent, CustomRectanglePink, CustomRectangleGreen } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import MasksHelper from 'utils/src/masks';
import Colors from 'constants/Colors';
import DayPicker from 'react-day-picker';
import { GlobalAuthContext, GlobalLoaderContext, GlobalOperationContext } from 'store/context';
import Loader from 'components/Loader';
import TagsList from 'components/TagList';
import SearchField from 'components/Form/SearchField';
import ComboBox from 'components/Form/ComboBox3';
import Icon from 'components/Icon';
import Subtitle from 'components/SubTitle'
import Mask from 'utils/src/mask';

export default function Page10(props) {
  console.log(props);

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const isClient = authContext.enumProfile === 1 ? true : false;
  const match = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  const [validations, setValidations] = useState({});
  const formikRef = useRef(null);
  const masks = new MasksHelper();
  const [comboBoxSearch, setComboBoxSearch] = useState({});
  const [vazio, setvazio] = useState([]);
  const [contactType, setContactType] = useState();
  const [valueEU, setValueEU] = useState('');

  //combo
  /* let tipoPrazo = {
    determinado:"determinado",
    naoDeterminado:"não determinado"
  } */
  let tipoPrazo = [
    {
      label:"Determinado",
      value:"determinado"
    },
    {
      label:"Não determinado",
      value:"naodeterminado"
    }
  ]

  //redirect
  const goToLoginPage = () => {
    history.push('/login');
  };
  const goBack = () => {
    history.goBack();
  }
  
  const goToPage11 = (body) => {

    history.push({ pathname: '/embed/page11', state: { page10Data: body } });
  };

  
  // main execution
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const [initial, setInitial] = useState({
    fullName: location.state.page8Data? location.state.page8Data.fullName : '',
    email: location.state.page8Data ? location.state.page8Data.email : '',
    name: location.state.page8Data ? location.state.page8Data.fullName.split(' ') : '',
    chosenbutton:location.state.page8Data? location.state.page8Data.chosenbutton : '',
    birthdate: location.state.page8Data?location.state.page8Data.birthdate : '',
    cpf: location.state.page8Data?location.state.page8Data.cpf : '',
    years: location.state.page8Data?location.state.page8Data.years : '',
    chosenvalue:location.state.page8Data?location.state.page8Data.chosenvalue : '',
    campoPrazoDeterminado:  location.state.page8Data? location.state.page8Data.campoPrazoDeterminado : '',
    tempoDesejado: location.state.page8Data? location.state.page8Data.tempoDesejado : '',
  })
  
  
  //validação de campo
  const createValidation = () => {
    let val = yup.object().shape({
      tempoDesejado: yup.string().required("* Campo obrigatório"),
    });
    setValidations(val);
  }

/*   const verifyPattern = (fieldType) => {

          if (fieldType) {
            let m;
            if (fieldType == "percentage") {
              m = masks.getPercentage("BR-brazil", 2 || null, "5000000" || "9999", "7900" || "0");
            }else{
              m = masks.getMask(fieldType || null, "BR-brazil", 2 || null,"9999999" || null,"500000" || null, "7900" || null)
            }
            return m;
          }
         
  }
 */
  let investValueCalculate= () => {

    let auxSplit = initial.chosenvalue.split('R$');
    let auxSplit2 = initial.years;
    let auxParse = parseInt(auxSplit[1]);
    let auxParse2 = parseInt(auxSplit2);

    let a = Mask.currency({
      value: ((auxParse2 * 12) * auxParse),
      lang: "pt-br",
      currency: 'BRL',
      style: 'currency'
      })

    return a;
  }

 /*  let investValue=()=>{
    return(
      <>
        <h5 style={{margin: "0px"}}>{investValueCalculate()}</h5>
      </>
    )
  } */

  let messageHeader = () => {
    return (
      <><div>
        <h4 style={{ fontWeight: "bold", marginTop: "10px" }}>
          {initial.name[0]}, confira a simulação que
          <br />
          preparamos para você:
        </h4>
      </div>
      </>
    );
  }

  let messageBodyTop = () => {
    return (
      <><div>
        <h5 style={{ fontWeight: "bold" }}>
          <div style={{ textTransform: "capitalize", display: "inline-flex" }}>{`${initial.name[0]}`}</div> digite aqui o código de verificação
          <br />
          que acabamos de te enviar via e-mail.
        </h5>
      </div>
      </>
    );
  }



  let messageBodyBottom = () => {
    return (
      <><div>
        <h6 style={{ cursor: "pointer" }}
          onClick={() => {
            history.replace({ pathname: '/embed/page4', state: { page4DataBack: { ...initial } } });
          }}>
          Quero trocar meu e-mail
        </h6>
      </div>
      </>
    );
  }

  const handleResend = () => {
    /* 
    
    //Atributo que deve ser enviado para a chamada enviar novamente o e-mail
    location.state.page4Data.email 
    
    
    */
    /* if(props.match.params.id){
      body.idPerson = props.match.params.id;
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestSavePerson(body)
      .then(res => res.json()).then(response => {
        loading.stop();
        goBack();
        if (response.ret_code != 200) mc.error(response.ret_msg_details);
      }).catch(() => {
        loading.stop();
        mc.error("An error happened, please try again.");
      }); */

  }




  useEffect(() => {
    //loading.start();
    async function loadContent() {
      await createValidation();
    }
    loadContent();
    //loading.stop();
  }, [initial])

  const handleSubmit = (body) => {
    goToPage11(body)
    /* let formattedBody = {...initial};*/
    /* if(props.match.params.id){
      body.idPerson = props.match.params.id;
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestSavePerson(body)
      .then(res => res.json()).then(response => {
        loading.stop();
        goBack();
        if (response.ret_code != 200) mc.error(response.ret_msg_details);
      }).catch(() => {
        loading.stop();
        mc.error("An error happened, please try again.");
      }); */

  }

  return (
    <>
      <Row>
        <Col>

        </Col>
        <Col style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text
          //onClick={() => { console.log('SEARCH', values); }} 
          ></Text>
          <button onClick={(e) => { e.stopPropagation(); e.preventDefault() }} style={{ opacity: 0, width: 0, height: 0 }}></button>
        </Col>

      </Row>
      <Formik
        innerRef={formikRef}
        initialValues={initial}
        enableReinitialize={true}
        /* initialValues={{ typeOfCover: props.match.params.idProduct, notes: '', iConfirmThatAllNeededDocumentsHaveBeenReceived: false, highlyConfidenticial: false, obligor: [{}], guarantor: [{}], borrower: [{}], facility: [{}], attachments: [] }} */
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={validations}

        render={({ values, setFieldValue, resetForm }) => (
          <Form>
            {/* <Row><h5 style={{ margin: "0px 0px 0px 15px", fontWeight: "normal" }} onClick={() => { history.goBack() }}>voltar</h5></Row> */}
            <Row style={{ textAlign: "center", justifyContent: "center" }}>{messageHeader()}</Row>
            <Row><hr style={{ width: "100%", boxShadow: "rgba(0, 0, 0, 0.05) 1px 3px 5px 1px" }} /></Row>

            <Row>
              <CustomRectanglePink>
                <div style={{textAlign: "center", placeContent: "center"}}>
                <p style={{margin: "0px"}}>Valor Investido</p>
                  <h2 style={{margin: "0px"}}>{investValueCalculate()}</h2>
                <p style={{margin: "0px"}}>Seu investimento no período</p>
                </div>
              </CustomRectanglePink>
              <CustomRectangleGreen>
              <div style={{textAlign: "center", placeContent: "center"}}>
                <p style={{margin: "0px"}}>Valor Investido</p>
                  <h2 style={{margin: "0px"}}>{investValueCalculate()}</h2>
                <p style={{margin: "0px"}}>Seu investimento no período</p>
                </div>
              </CustomRectangleGreen>
            </Row>

            <Row style={{textAlign: "center", placeContent: "center"}}>
            <h6>Os dados não mentem. <br/>
            Quer ver? Arraste seu dedo no gráfico e descubra a evolução do seu patrimônio no decorrer dos próximos anos.
            </h6>
            </Row>
            <Row>
              <Col>
              <Field
                    readOnly
                    type="text"
                    label={'Desejo receber o valor mensalmente via:'}
                    name={'campoPrazoDeterminado'}
                    value={values.campoPrazoDeterminado}
                    onChange={(e) => setFieldValue('campoPrazoDeterminado', e)}
                    component={InputField}
                    disabled={true}
                  />
              </Col>
            </Row>
            
            {values.campoPrazoDeterminado === "determinado"? 
          
          <Row>
              <Col>
                <Field
                  name="tempoDesejado"
                  label="Por quantos anos?"
                  isRequired={true}
                  component={InputField}
                  disabled={true}
                />
              </Col>
            </Row>
          : ''
          }
            
            <Row style={{ textAlign: "center", justifyContent: "center" }}>
              <h6>Está em dúvida? Não se preocupe, depois você poderá<br />
              alterar este valor sempre que desejar.</h6>
            </Row>

            <ButtonContainer style={{ justifyContent: "center" }}>
              {
                //<Button forth onClick={() => goBack()}>&lt; Back</Button>
              }
              <ButtonContent>

                <ButtonMiradorOrange
                  type="submit"
                  primary
                  id="btnSubmit"
                  disabled={ values.campoPrazoDeterminado === ''? true : false}
                >Pronto!
                </ButtonMiradorOrange>
              </ButtonContent>
            </ButtonContainer>
                <Row style={{placeContent: "center", margin:"20px"}}>
                <ButtonMiradorWhite
                onClick={() => { 
                  history.replace({ pathname: '/embed/page7', state: { page7DataBack: { ...initial } } })
                 }}
                  > <p style={{margin: "0px"}}> Ops! Quero alterar os valores <br/> e simular novamente </p>
                </ButtonMiradorWhite>
                </Row>
                <Row><br/></Row>
          </Form>
        )}
      >
      </Formik>
      {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
    </>
  )
}